import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { api, ApiError } from "../api/client";
const AuthContext = createContext(undefined);
export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    async function refresh() {
        try {
            const me = await api.get("/auth/me");
            setUser(me);
        }
        catch (e) {
            if (e instanceof ApiError && e.status === 401) {
                setUser(null);
            }
            else {
                throw e;
            }
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        refresh();
    }, []);
    async function login(email, password) {
        const me = await api.post("/auth/login", { email, password });
        setUser(me);
    }
    async function signup(input) {
        const me = await api.post("/auth/signup", input);
        setUser(me);
    }
    async function logout() {
        try {
            await api.post("/auth/logout");
        }
        finally {
            setUser(null);
        }
    }
    return (_jsx(AuthContext.Provider, { value: { user, loading, login, signup, logout, refresh }, children: children }));
}
export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx)
        throw new Error("useAuth must be inside AuthProvider");
    return ctx;
}
